<template>
    <b-form-checkbox
        class="apprentice-checkbox answer-list-checkbox"
        v-model="checkedValue"
        @change="onChange($event, itemIn.id)"
        value="1"
        unchecked-value="0"
        :disabled="!canAnswer">
        {{ indexIn }}. {{ itemIn.value }}
    </b-form-checkbox>
</template>

<script>
export default {
    name: 'design-2021-assignment-show-answer-list-checkbox-component',
    props: ['partIn', 'itemIn', 'canAnswer', 'projectId', 'indexIn'],
    data() {
        return {
            checkedValue: 0,
        };
    },
    mounted() {
        this.resetValue();
    },
    methods: {
        resetValue() {
            if (!this.partIn.hasAnswer()) {
                this.checkedValue = 0;
            } else {
                let target_item = null;

                for (const item of this.partIn.getAnswer().list_checks) {
                    if (item.item_id === this.itemIn.id) {
                        target_item = item;
                        break;
                    }
                }

                if (target_item != null) {
                    this.checkedValue = 1;
                }
            }
        },
        onChange(value, id) {
            if (value === 0 && (!this.partIn.hasAnswer() || !this.partIn.getAnswer().hasListCheck(id))) {
                return;
            }

            if (!this.partIn.hasAnswer()) {
                const data = {
                    value: {
                        item_id: id,
                    },
                    part_id: this.partIn.id,
                    project_id: this.projectId,
                };

                this.axios.post(this.routes.assignmentAnswer(), data).then(
                    (response) => {
                        this.partIn.addRelation('answers', response.data);
                    },
                    (error) => {
                        this.alert.ajaxError(error);
                    },
                );
            } else {
                const data = {
                    check_value: value,
                    item_id: this.itemIn.id,
                    answer_id: this.partIn.getAnswer().id,
                };

                if (!this.partIn.getAnswer().hasListCheck(id)) {
                    // create list item answer
                    this.axios.post(this.routes.assignmentAnswerList(), data).then(
                        (response) => {
                            this.partIn.getAnswer().addRelation('list_checks', response.data);
                        },
                        (error) => {
                            this.alert.ajaxError(error);
                        },
                    );
                } else {
                    // update
                    this.axios
                        .post(
                            this.routes.assignmentAnswerListUpdateCheck(this.partIn.getAnswer().getListCheck(id).id),
                            data,
                        )
                        .then(
                            (response) => {
                                if (!response.data || !response.data.length) {
                                    this.partIn.getAnswer().getListCheck(id).remove();
                                } else {
                                    this.partIn.getAnswer().getListCheck(id).update(response.data);
                                }
                            },
                            (error) => {
                                this.alert.ajaxError(error);
                            },
                        );
                }
            }
        },
    },
};
</script>

<style scoped lang="scss">
.answer-list-checkbox ::v-deep {
    label {
        line-height: 1.2;

        &:hover {
            cursor: pointer;
        }
    }
}
</style>
